/**
 * Function to return a Postal Code verifying digit
 * 
 * @param {string} value Postal Code to be calculated
 * 
 * @returns {string} Postal Code's verifying digit
 * 
 * @example
 * // returns 6
 * cepVerifyingDigit('71010050');
 * 
 * @example
 * // returns 0
 * cepVerifyingDigit('05311000');
 */
export function getPostalCodeVerifyingDigit(value) {
  const sum = value
    .toString() // ensure value is a string
    .split('') // creates an array with every digit
    .map(Number) // copies the array as an array of numbers
    .reduce((a, b) => a + b); // sum of all digits;

  if (sum % 10 === 0) return '0'; // if sum is multiple of 10, return '0'

  const multiple = Math.ceil(sum / 10) * 10; // gets next multiple of 10 relative to sum
  const result = multiple - sum; // calculates verifying digit

  return result.toString(); // returns verifying digit as string
}